/* import __COLOCATED_TEMPLATE__ from './default.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
import type { CodeDescPayload } from 'volta/models/search-entry';
import type SearchEntry from 'volta/models/search-entry';

interface BvAppSearchEntryDefaultSignature {
  Args: {
    entry: SearchEntry<CodeDescPayload>;
  };
  Element: HTMLElement;
}

const BvAppSearchEntryDefaultComponent = templateOnlyComponent<BvAppSearchEntryDefaultSignature>();

export default BvAppSearchEntryDefaultComponent;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'BvAppSearch::Entry::Default': typeof BvAppSearchEntryDefaultComponent;
    'bv-app-search/entry/default': typeof BvAppSearchEntryDefaultComponent;
  }
}
